module.exports = __webpack_public_path__ + "img/content1_right.f870d2a.png";